import { Log } from '@lightningjs/sdk';

export function atvPromiseAll(promises: Promise<any>[] | Promise<any>) {
  if (!(promises instanceof Array)) {
    promises = [promises];
  }
  const wrappedPromises = promises.map(prom => wrapPromise(prom));
  return Promise.all(wrappedPromises);
}

/**
 * @template T
 * @param {Promise<T>} prom
 * @returns {Promise<T>}
 */
function wrapPromise<T>(prom: Promise<T>): Promise<T | undefined> {
  return new Promise(resolve => {
    if (!prom) resolve(undefined);
    prom
      .then(result => {
        resolve(result);
      })
      .catch(err => {
        Log.error(err);
        resolve(undefined);
      });
  });
}
